import React, { createContext, useContext, useState } from "react";

interface IStoreData {
  store_state: string;
  seller_state: string;
  notifications: number;
  order_numbers: number;
  name: string;
  logo_uid: string;
  user_full_name: string;
  stats: any;
}

interface StoreContextState {
  storeData: IStoreData;
  setStoreData: React.Dispatch<React.SetStateAction<any>>;
}

const StoreContext = createContext<StoreContextState | undefined>(undefined);

export { StoreContext };

export const useStoreContext = () => {
  const context = useContext(StoreContext);
  if (context === undefined) {
    throw new Error(
      "useStoreContext must be used within a StoreContextProvider"
    );
  }
  return context;
};

export const StoreContextProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [storeData, setStoreData] = useState<any>(/* Initial state here */);

  const value = { storeData, setStoreData };

  return (
    <StoreContext.Provider value={value}>{children}</StoreContext.Provider>
  );
};
